//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DetailsSocial',
  props: {
    title: { type: String, default: '其他連結：' },
    line: { type: String, default: '' },
    fb: { type: String, default: '' },
    fbm: { type: String, default: '' },
    tg: { type: String, default: '' },
    ig: { type: String, default: '' },
  },
};
